<template>
  <div class="page-home">
    <div class="space-20"></div>
    <transition-group name="fade" mode="out-in">
      <loading key="loading" v-if="!loaded.skus || !loaded.productsMenu"></loading>
      <div key="content" v-show="loaded.skus && loaded.productsMenu" class="container">
        <p>
          <router-link :to="{name: 'home'}">Home</router-link>
          <i class="fa fa-angle-double-right"></i> {{ subcategory.name }}
        </p>
        <div class="row">
          <div class="col-md-3">
            <list-products-menu :subcategory-id="subcategoryId" @loaded="loadedEvent"></list-products-menu>
          </div>
          <div class="col-md-9">
            <list-skus parent="subcategory" :parent-id="subcategoryId" @loaded="loadedEvent"></list-skus>
          </div>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
  import {mapActions} from 'vuex'
  import ListProductsMenu from './../components/ListProductsMenu'
  import ListSkus from './../components/ListSkus'

  export default{
    name: 'PageSubcategory',
    components: {
      ListProductsMenu,
      ListSkus
    },
    data () {
      return {
        subcategoryId: this.$route.params.subcategoryId,
        subcategory: false,
        tagInterval: false,
        loaded: {
          skus: false,
          productsMenu: false
        }
      }
    },
    mounted () {
      this.getSubcategory()
    },
    beforeDestroy () {
      if (this.tagInterval) {
        clearInterval(this.tagInterval)
      }
    },
    methods: {
      loadedEvent (type) {
        if (type === 'skus') this.loaded.skus = true
        if (type === 'products_menu') this.loaded.productsMenu = true
      },
      getSubcategory () {
        this.loadSubcategory({id: this.subcategoryId})
          .then((response) => {
            this.subcategory = response.data
          }, (response) => {
            console.log('error: Loading subcategory resource from API')
          })
      },
      ...mapActions(['loadSubcategory'])
    }
  }
</script>


// WEBPACK FOOTER //
// PageSubcategory.vue?6192ecc5